import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import he from 'he';
import * as irSearchActions from '../../../redux/actions/irSearchActions';
import LoadingBar from '../../common/LoadingBar';
import FilterTable from '../../common/FilterTable';
import UpdateFromPacer from '../../common/UpdateFromPacer';
import PopupError from '../../common/PopupErrorComponent/PopupError';

import './CaseAttorneys.less';

export class CaseAttorneys extends Component {

  componentDidMount() {
    if (this.props.purchase_right_away)
      this.purchaseAttorneyData();
    else
      this.getAttorneyData();
  }

  getAttorneyData = () => {
    this.props.dispatch(irSearchActions.getCaseData({
      type: 'attorneys',
      case_uuid: this.props.case_uuid,
    }));
  }

  purchaseAttorneyData = () => {
    this.props.dispatch(irSearchActions.purchaseCaseData({
      type: 'attorneys',
      case_uuid: this.props.case_uuid,
      purchase_right_away: this.props.purchase_right_away,
    }));
  }

  render() {
    if (!this.props.dataReady) return <LoadingBar/>;

    const Attorneys = !this.props.attorneys.empty ? this.getAttorneysTableBody(this.props.attorneys) : [];

    return (
      <div className="case-attorneys">
        <PopupError errors={this.props.error} />
        <a href={`/attorneys/export-xlsx/${this.props.case_uuid}`} className="form-submit"
           style={{ float: "right", marginLeft: '4px' }}>
          <i className="fa  fa-file-excel-o"></i> Download Excel
        </a>
        <a href={`/attorneys/export-csv/${this.props.case_uuid}`} className="form-submit" style={{ float: "right" }}>
          <i className="fa fa-table"></i> Download CSV
        </a>
        <FilterTable>
          {!!Attorneys.length ? (
            <table className="sticky-enabled tablesorter">
              <thead>
              <tr>
                <th><span>Attorney</span></th>
                <th><span>Type</span></th>
                <th><span>Party</span></th>
              </tr>
              </thead>
              <tbody>
              {Attorneys}
              </tbody>
            </table>
          ) : (
            <div
              className="ir-search-status-message messages warning"
            >There Are No Attorneys For This Case</div>
          )}
        </FilterTable>
        <UpdateFromPacer
          pacerUpdateHandler={this.purchaseAttorneyData.bind(null, this.props.case_uuid, 'attorneys', true)}
          pacerReceipt={this.props.receipt}
          lastUpdated={this.props.lastUpdated}/>
      </div>
    )
  }

  getAttorneysTableBody = (attorneys) => {
    if (_.get(attorneys, '[0][0]') == 'empty') return [];

    return attorneys.map((item, key) => {
      if (Object.keys(item).length) {
        return <tr key={key}>
          <td>
            {this.getAttorneyInfo(item.attorney)}
          </td>
          <td>representing</td>
          <td>
            {this.getAttorneyParty(item.associated)}
          </td>
        </tr>
      }
    })
  };

  getAttorneyParty = (associated) => (
    associated.map((el, key) => (
        <div key={key}>
          <strong> {he.decode(el.name || '')} </strong>
          {<p> {this.getFormattedAddress(el.address)} </p>}
          {el.role ? <p><i>({el.role})</i></p> : ''}
          {el.phone ? <p> t: {el.phone} </p> : ''}
          {el.fax ? <p> f: {el.fax} </p> : ''}
          {el.email ? <p>{el.email}</p> : ''}
        </div>
      )
    )
  );

  getAttorneyInfo = (attorney) => (
    <div className="ir-search-card">
      <strong> {
        attorney.profile_link
          ? <a href={attorney.profile_link}> {he.decode(attorney.name || '')} </a>
          : he.decode(attorney.name || '')
      }</strong><br/>
      {this.getFormattedAddress(attorney.address)}
      {attorney.phone ? <div> t: {attorney.phone} </div> : ''}
      {attorney.fax ? <div> f: {attorney.fax} </div> : ''}
      {attorney.email ? <div> {attorney.email} </div> : ''}
      {attorney.lead ? <div><i> ({attorney.lead}) </i></div> : ''}
      {attorney.assigned_date ? <div><i> Assigned: ({attorney.assigned_date}) </i></div> : ''}
      {attorney.terminated_date ? <div><i> Terminated: ({attorney.terminated_date}) </i></div> : ''}
    </div>
  );

  getFormattedAddress(address) {
    if (address) {
      let splitAddress = address.split(/\r?\n/);
      return splitAddress.map((el, idx) => {
        if (idx < splitAddress.length)
          return [el, <br/>];
      })
    }
  }
}

const mapStateToProps = (state) => {
  const irSearch = state.get('irSearch').toJS();

  return {
    dataReady: irSearch.data_ready,
    attorneys: irSearch.data,
    receipt: irSearch.receipt,
    lastUpdated: irSearch.lastUpdated,
    error: irSearch.error,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseAttorneys)



// WEBPACK FOOTER //
// ./src/components/case/attorneys/CaseAttorneys.js